import { FC } from 'react';
import classNames from 'classnames';
import { Button, ButtonVariant } from '@edikk-edikk/ui';
import { FormattedMessage } from 'react-intl';
import { Filter } from '@edikk-edikk/icon/Filter';
import AdvertListFilterControlsCss from '#srcCssModules/advert/list-filter/advert-list-filter-controls.module.scss';
import { useFilterContext } from '#advertList/components/filter/hooks/use-filter-context';

const Toggle: FC = () => {
  const {
    isVisible,
    open,
    hide,
  } = useFilterContext();

  const handlerClick = () => {
    if (isVisible) {
      hide();
    } else {
      open();
    }
  };

  return (
    <Button
      variant={ButtonVariant.unstyled}
      additionalClassName={classNames(
        AdvertListFilterControlsCss.advertListFilterControls__action,
        AdvertListFilterControlsCss.advertListFilterControls__action_all,
      )}
      onClick={handlerClick}
      icon={{
        svg: {
          Component: Filter,
          isWithoutFill: true,
        },
      }}
    >
      <FormattedMessage defaultMessage="All filter" />
    </Button>
  );
};

export { Toggle };
